import { InjectionToken } from '@angular/core';
import { Order } from '@rivethealth/data/super-table';
import { Observable, Subject } from 'rxjs';
import { ViewState } from './super-table.component';

export const SUPER_TABLE_CONTEXT_TOKEN = new InjectionToken<SuperTableContext>(
  'SUPER_TABLE_CONTEXT',
);

export interface SuperTableContext {
  [x: string]: any;
  readonly changeView: Subject<Partial<ViewState>>;
  readonly changeSort: Subject<Order>;
  readonly effectiveSort: Observable<Order | null>;
}

export const CHECKBOX_PX = 32;
